import React, { useState, useEffect } from 'react';
import './About.css'; // Import a separate CSS file for styling

const About = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(1);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex % 5) + 1); // Change from 1 to 2, 2 to 3, ..., 5 to 1
    }, 3000);

    // Clear the interval on component unmount to prevent memory leaks
    return () => clearInterval(intervalId);
  }, []);

  const renderBackgroundImages = () => {
    const backgroundImages = [];
    for (let i = 1; i <=5; i++) {
      backgroundImages.push(
        <div key={i} className={`background-image image${i}`} style={{ display: i === currentImageIndex ? 'block' : 'none' }}></div>
      );
    }
    return backgroundImages;
  };

  return (
    <div className="about-container">
      {renderBackgroundImages()}
      <div className="content">
        <h3>बुंदेलखंड - Central India</h3>
        <h4 style={{ margin:'20px'}}>बुंदेलखंड, मध्य भारत स्थित, विशेष रूप से बुंदेली भाषा के साथ, ऐतिहासिक और प्राकृतिक सुंदरता का एक अद्वितीय समृद्ध स्थान है।</h4>
       
        <h4 style={{ margin:'20px'}}>Bundelkhand, located in central India, particularly known for the Bundeli language, is a unique and prosperous place with historical and natural beauty.</h4>

      </div>
    </div>
  );
};

export default About;
